import { Alert, Box, Card, Typography } from '@mui/material';
import { SendPrizeEmailButton } from '@/pages/LeaderboardPage/SendPrizeEmailButton.tsx';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';
import { TournamentLeaderboardData } from '@/@types/api.types.ts';

interface TournamentControlBarProps {
  leaderboardData: TournamentLeaderboardData;
}

export const TournamentControlBar = ({
  leaderboardData,
}: TournamentControlBarProps) => {
  const { leagueId, tournamentId } = useAppSearchParams();

  if (!leagueId || !tournamentId) return null;

  return (
    <Card style={{ padding: 20 }}>
      <Box>
        <Typography variant='h5' component='div' sx={{ marginBottom: 2 }}>
          Message
        </Typography>
        <SendPrizeEmailButton />
      </Box>

      {leaderboardData && (
        <Alert sx={{ marginTop: 2 }} severity='info'>
          {`Tournament Scoring progress: ${leaderboardData.completedScoringCount} / ${leaderboardData.selectionsCount}`}
        </Alert>
      )}
    </Card>
  );
};
